module.exports = __webpack_public_path__ + "8572cf17ecb2ff6f02f7f6864f42c59a.png";